/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-04-10 17:06:22
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-08-04 10:16:37
 */
import { FetchPolicy, gql } from '@apollo/client'
import { config } from '@config'
import { ACTIVITY_HIERARCHY_MAP, DEFAULT_ACTIVITY_HIERARCHY } from '@constants'
import {
  BuyingSessionAssortmentSection,
  BuyingSessionAssortmentType,
  BuyingSessionGroupNavView,
  ChannelSubSection
} from '@modules/common/models/enums/BSGroupAndBSNav'
import { ListViewFieldMapping } from '@modules/common/models/enums/ListViewFieldMapping'
import {
  ImageAttributes,
  Modules,
  Operations
} from '@modules/common/models/enums/NodeAttributes'
import { AttributeValueType } from '@modules/common/models/enums/ProductAttributeValueType'
import { ProductCardAttributeEnum } from '@modules/common/models/enums/ProductCardAttributeEnum'
import { ProductTypeForSearchFilterEnum } from '@modules/common/models/enums/SearchFilterEnums'
import { UserRoles } from '@modules/common/models/enums/UserRoles'
import { ViewTabs } from '@modules/common/models/enums/Views'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import { WholesaleGirdProductFieldMapping } from '@modules/common/models/enums/WholesaleGirdProductFieldMapping'
import { IGridViewProduct } from '@modules/common/models/interfaces/WholesaleGridProduct'
import { CriteriaOperationType } from '@modules/models'
import { WS_CLUSTER_ASSORTMENT_PRODUCTS } from '@modules/wholesale/assortmentProductWrapper/graphql/getClusterAssortmentProducts'
import { GET_CLUSTER_ASSORTMENT_SUMMARY } from '@modules/wholesale/assortmentProductWrapper/graphql/getClusterAssortmentProductsSummary'
import { BuyTargetSync } from '@modules/wholesale/buyingSessionGroupProductWrapper/services/buyTabService'
import { productForecastUIStore } from '@modules/wholesale/buyingSessionGroupProductWrapper/stores/productForecastUIStore'
import { FilterKeys } from '@modules/wholesale/FilterModal/enums/FilterEnums'
import { IFilter, ISelectedFilter } from '@modules/wholesale/FilterModal/interface/Filter'
import { GET_BUYING_SESSION_PRODUCT_DETAILS } from '@modules/wholesale/productDetail/graphql/findBuyingSessionProductDetails'
import { isBuyingSessionRestrictedForTag } from '@modules/wholesale/wsNavigations/constants/Tags'
import { getHighestUser } from '@routes'
import CommentService from '@services/commentService'
import {
  getMediaCentricURI,
  getViewTabsToRender,
  isZAM,
  syncToBsgElasticSearch
} from '@services/commonServices'
import { getDefaultImage } from '@services/imageService'
import { storage } from '@services/storageService'
import { hasUserRoles, PERMISSION_MAP } from '@services/userRoleService'
import { IDoorOrder } from '@services/wholesale/OrderManagementService'
import { VIPBuyingSessionProduct } from '@services/wholesale/productService'
import {
  VIPOrderProduct,
  wholesaleCollectionService
} from '@services/wholesale/wholesaleCollectionService'
import { collectionKpiViewDefinitionService } from '@services/wholesale/wsCollectionKpiViewDefinitionService'
import { collectionListViewDefinitionService } from '@services/wholesale/wsCollectionListViewDefinitionService'
import { apolloClient, nav, stores, strings } from '@stores'
import axios, { AxiosError } from 'axios'
import axiosRetry from 'axios-retry'
import PQueue from 'p-queue'
import chunk from 'lodash/chunk'
import capitalize from 'lodash/capitalize'
import cloneDeep from 'lodash/cloneDeep'
import concat from 'lodash/concat'
import endsWith from 'lodash/endsWith'
import every from 'lodash/every'
import filter from 'lodash/filter'
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import groupBy from 'lodash/groupBy'
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import keys from 'lodash/keys'
import map from 'lodash/map'
import some from 'lodash/some'
import toNumber from 'lodash/toNumber'
import memoize from 'memoize-one'
import { action, computed, observable } from 'mobx'
import { computedFn } from 'mobx-utils'
import * as qs from 'query-string'
import { ADD_CHANNEL_TO_BUYING_SESSION_PRODUCT } from '../graphql/addChannelToBuyingSessionProduct'
import { ADD_DROP_TO_BUYING_SESSION_PRODUCT } from '../graphql/addDropToBuyingSessionProduct'
import { WS_ADD_FREE_TAG_TO_BUYING_SESSION_PRODUCT } from '../graphql/addFreeTagToBuyingSessionProduct'
import { ADD_SALES_PERIOD_TO_BUYING_SESSION_PRODUCT } from '../graphql/addSalesPeriodToBuyingSessionProduct'
import { WS_BUYING_SESSION_PRODUCTS } from '../graphql/buyingSessionProducts'
import { GET_BUYING_SESSION_PRODUCT } from '../graphql/getBuyingSessionPrduct'
import { REMOVE_CHANNEL_FROM_BUYING_SESSION_PRODUCT } from '../graphql/removeChannelFromBuyingSessionProduct'
import { REMOVE_CLUSTER_FROM_BUYING_SESSION_PRODUCT_EXCLUSION } from '../graphql/removeClusterFromBSPExclusion'
import { REMOVE_DROP_FROM_BUYING_SESSION_PRODUCT } from '../graphql/removeDropFromBuyingSessionProduct'
import { WS_REMOVE_FREE_TAG_TO_BUYING_SESSION_PRODUCT } from '../graphql/removeFreeTagFromBuyingSessionProduct'
import { REMOVE_SALES_PERIOD_FROM_BUYING_SESSION_PRODUCT } from '../graphql/removeSalesPeriodFromBuyingSessionProduct'
import { WS_TOGGLE_FAVORITE_FLAG_FOR_BS_PRODUCT } from '../graphql/toggleFavoriteFlagForBuyingSessionProduct'
import { CommonService } from '../services/commonService'
import { ProductForecastKPIsService } from '../services/productKPIsService'
import { counterOfferUIStore } from './CounterOffer/CounterOfferUIStore'
import { addOrRemoveClientExclusion } from '@services/productDetailService'
import orderBy from 'lodash/orderBy'
import reduce from 'lodash/reduce'
import { WithTranslationProps } from 'react-i18next'
import { BBProductSelectionStore } from './BBProductSelectionStore'
import { isNumber, reverse, uniqBy } from 'lodash'

export class WSBuyingSessionProductStore {
  private syncBuyTargetService = new BuyTargetSync()
  private commonService = new CommonService()
  private commentService = new CommentService()
  productSelectionStore = new BBProductSelectionStore()
  @observable openMessageDialog = false
  @observable displayMessage = ''
  @observable openConfirmationDialog = false
  @observable isDeleteInProgress = false
  @observable displayTitle = ''
  @observable buyingSessionProductId = ''
  @observable tagId = ''
  @observable showConfirmationDeleteClusterAssortmentProduct = false
  @observable isMutationInProgress = false
  @observable selectedClusterAssortmentProduct = {}
  @observable selectedClusterAssortmentId = null
  @observable onDeleteConfirmationClick = null
  @observable selectedChipsForDrag = []
  @observable rightSideSelectedChipsForDrag = []
  @observable isWindowSelectMouseClick = false
  @observable lastSelectedForShiftKey = null
  @observable lastShiftStartAndEndIndex = null
  @observable rightSideLastSelectedForShiftKey = null
  @observable rightSideLastShiftStartAndEndIndex = null
  @observable isWindowSelectionGoingOn = false
  @observable isBulkOpPopupDisplayed = false
  @observable bulkOpSelectedTab = strings.tagTypes.channel
  @observable bulkOpSelectedEntities = {}
  @observable bulkOpProductsCountWithoutWholesaleChannel = 0
  @observable bulkOpProductsCountFromClosedBS = 0
  @observable bulkOpCoreProductsCount = 0
  @observable freeTagsEnums = []
  @observable isSyncInProcess = false
  @observable products = null
  @observable areProductsAvaliable = false
  @observable bulkOpProductsCountWithoutRetailChannel = 0
  @observable bsgData = null
  @observable isBulkOpSaveActive = false
  @observable bulkOpSaveProgress = 0
  @observable bulkOpSaveError: AxiosError<any> | Error = null

  private _bulkOpQueue?: PQueue
  private _abortController?: AbortController

  @observable productForecastKPIData = []
  @observable productBuyKPIData = []
  @observable wholesaleBuyProducts = null
  @observable retailBuyProducts = null
  @observable retailBuyComments = null
  @observable isKPIDataLoading = false
  @observable assortmentProduct = {
    loading: false,
    error: '',
    items: []
  }

  @observable.ref clusterAndEle = null
  query: any = {}

  @action updateBSGData = data => {
    this.bsgData = data
  }

  updateProductsRefetchQuery = query => {
    this.query.productsRefetchQuery = query
  }

  /**
   * Handles all tag delete operations from collection list view.
   * @param product buyingSession Product
   * @param tagId chip id
   * @param tagType type of chip
   */
  @action
  handleTagDelete = async (
    product,
    tagId,
    tagType,
    t: WithTranslationProps['i18n']['t']
  ) => {
    let shouldBSPSync = false

    switch (tagType) {
      case ListViewFieldMapping.WholesaleClusters:
      case ListViewFieldMapping.RetailClusters: {
        await this.deleteClusterFromBuyingSessionProduct(product, tagId)
        shouldBSPSync = true
        break
      }
      case ListViewFieldMapping.RetailFreeTags:
      case ListViewFieldMapping.WholesaleFreeTags: {
        await this.removeFreeTagFromBuyingSessionProduct(product, tagId)
        shouldBSPSync = true
        break
      }
      case ProductCardAttributeEnum[strings.drop]:
      case ListViewFieldMapping[strings.Drops]: {
        this.showDropDeleteConfirmationDialog(product, t)
        break
      }
      case ListViewFieldMapping[strings.Channels]: {
        this.showDeleteConfirmationDialog(product, tagId, t)
        break
      }
      case ListViewFieldMapping.ExcludedZones: {
        this.removeZoneExclusionFromBuyingSessionProduct(product, tagId)
        break
      }

      case ProductCardAttributeEnum.retailClusterExclusion: {
        await this.removeClusterFromExcludedClusters(product, tagId)
        shouldBSPSync = true
        break
      }

      case ProductCardAttributeEnum.retailSalesPeriod:
      case ListViewFieldMapping.SalesPeriod: {
        await this.removeSalesPeriodFromBuyingSessionProduct(product)
        shouldBSPSync = true
        break
      }
      case ProductCardAttributeEnum.wholesaleClusterExclusion: {
        await this.removeClusterFromExcludedClusters(product, tagId)
        shouldBSPSync = true
      }
    }
    if (shouldBSPSync) {
      syncToBsgElasticSearch([product.node.Id])
    }
  }

  @action
  handleTagClick = (product, tagId, tagType, event, isFromBulkPopup?) => {
    switch (tagType) {
      case ListViewFieldMapping.RetailClusters: {
        this.showClusterStatuses(product, tagId, event.target, isFromBulkPopup)
        break
      }
      default:
    }
  }

  @action handleMultiSelectByShiftKey = (entity, allEntities, isRightSideSelection) => {
    let updatedSelectionArray = isRightSideSelection
      ? this.rightSideSelectedChipsForDrag
      : this.selectedChipsForDrag
    let updatedLastSelectedForShiftKey = isRightSideSelection
      ? this.rightSideLastSelectedForShiftKey
      : this.lastSelectedForShiftKey
    let updatedLastShiftStartAndEndIndex = isRightSideSelection
      ? this.rightSideLastShiftStartAndEndIndex
      : this.lastShiftStartAndEndIndex
    if (updatedLastSelectedForShiftKey) {
      const itemsIndex = allEntities.map(ele => ele.Id)
      const startIndex = itemsIndex.indexOf(updatedLastSelectedForShiftKey.Id)
      const endIndex = itemsIndex.indexOf(entity.Id)

      // Select the range of items between the last and the current one
      const rangeStart = Math.min(startIndex, endIndex)
      const rangeEnd = Math.max(startIndex, endIndex)

      // Update selectedItems with the range of selected items
      const currentSelection = allEntities.slice(rangeStart, rangeEnd + 1)
      let deSelectLastRangeChips = updatedSelectionArray
      if (startIndex === updatedLastShiftStartAndEndIndex?.startIndex) {
        if (isNumber(updatedLastShiftStartAndEndIndex?.endIndex)) {
          const lastRangeStart = Math.min(
            startIndex,
            updatedLastShiftStartAndEndIndex?.endIndex
          )
          const lastRangeEnd = Math.max(
            startIndex,
            updatedLastShiftStartAndEndIndex?.endIndex
          )
          const lastRangeChips = allEntities.slice(lastRangeStart, lastRangeEnd + 1)
          deSelectLastRangeChips = deSelectLastRangeChips.filter(
            item => !lastRangeChips.some(ele => ele?.Id === item?.Id)
          )
        }
      }
      updatedSelectionArray = uniqBy(
        [...deSelectLastRangeChips, ...currentSelection],
        'Id'
      )
      updatedLastShiftStartAndEndIndex = { startIndex: startIndex, endIndex: endIndex }
    } else {
      const newSelectedItems = updatedSelectionArray.includes(entity.Id)
        ? updatedSelectionArray.filter(ele => ele?.Id !== entity.Id)
        : [...updatedSelectionArray, entity]
      updatedSelectionArray = newSelectedItems
      updatedLastSelectedForShiftKey = entity
    }
    this.setSelectedChipsAsPerSide(
      isRightSideSelection,
      updatedSelectionArray,
      updatedLastSelectedForShiftKey,
      updatedLastShiftStartAndEndIndex
    )
  }

  @action setSelectedChipsAsPerSide = (
    isRightSideSelection,
    updatedSelectionArray,
    updatedLastSelectedForShiftKey,
    updatedLastShiftStartAndEndIndex
  ) => {
    if (isRightSideSelection) {
      this.rightSideSelectedChipsForDrag = updatedSelectionArray
      this.rightSideLastSelectedForShiftKey = updatedLastSelectedForShiftKey
      this.rightSideLastShiftStartAndEndIndex = updatedLastShiftStartAndEndIndex
    } else {
      this.selectedChipsForDrag = updatedSelectionArray
      this.lastSelectedForShiftKey = updatedLastSelectedForShiftKey
      this.lastShiftStartAndEndIndex = updatedLastShiftStartAndEndIndex
    }
  }

  @action setIsWindowSelectionGoingOn = flag => {
    this.isWindowSelectionGoingOn = flag
  }

  @action onSelectAllTags = (entities, isRightHandSideOperation = false) => {
    if (isRightHandSideOperation) {
      this.rightSideSelectedChipsForDrag = cloneDeep(entities)
    } else {
      this.selectedChipsForDrag = cloneDeep(entities)
    }
  }

  get isMacOS() {
    return /Mac/.test(navigator.userAgent)
  }

  @action onMouseUpHandlerOnChip = (e, entity, isRightHandSideOperation = false) => {
    if (!(e?.ctrlKey || e?.metaKey || e?.shiftKey)) {
      if (!this.isWindowSelectionGoingOn) {
        const singleItem = [entity]
        this.setSelectedChipsAsPerSide(isRightHandSideOperation, singleItem, entity, null)
      }
    }
  }

  @action
  mouseDownHandlerForChips = (e, entity, allEntities, isRightSideSelection = false) => {
    if (e?.shiftKey) {
      this.handleMultiSelectByShiftKey(entity, allEntities, isRightSideSelection)
    } else if ((!this.isMacOS && e?.ctrlKey) || (this.isMacOS && e?.metaKey)) {
      let updatedSelectionArray = isRightSideSelection
        ? this.rightSideSelectedChipsForDrag
        : this.selectedChipsForDrag
      let updatedLastSelectedForShiftKey = isRightSideSelection
        ? this.rightSideLastSelectedForShiftKey
        : this.lastSelectedForShiftKey
      let updatedLastShiftStartAndEndIndex = isRightSideSelection
        ? this.rightSideLastShiftStartAndEndIndex
        : this.lastShiftStartAndEndIndex
      const alreadySelected = find(updatedSelectionArray, ele => ele?.Id === entity?.Id)
      if (!alreadySelected?.Id) {
        updatedSelectionArray.push(entity)
        updatedLastSelectedForShiftKey = entity
      } else {
        updatedSelectionArray = filter(
          updatedSelectionArray,
          ele => ele?.Id !== entity?.Id
        )
        let flagForUpdatingEndIndex = false
        const itemsIndex = allEntities.map(ele => ele.Id)
        const index = itemsIndex.indexOf(entity?.Id)
        const rangeAfterUnSelectionIndex = itemsIndex.slice(index + 1)
        let updatedLastSelection = rangeAfterUnSelectionIndex.find(
          el => updatedSelectionArray.findIndex(item => item?.Id === el) !== -1
        )
        if (!updatedLastSelection) {
          flagForUpdatingEndIndex = true
          const rangeBeforeUnSelectionIndex = itemsIndex.slice(0, index)
          updatedLastSelection = reverse(rangeBeforeUnSelectionIndex)?.find(
            el => updatedSelectionArray.findIndex(item => item?.Id === el) !== -1
          )
          if (
            updatedLastShiftStartAndEndIndex &&
            updatedLastShiftStartAndEndIndex?.startIndex <
              updatedLastShiftStartAndEndIndex?.endIndex
          ) {
            updatedLastShiftStartAndEndIndex.endIndex =
              updatedLastShiftStartAndEndIndex?.startIndex
          }
        }
        if (updatedLastSelection) {
          const newIndex = itemsIndex.indexOf(updatedLastSelection)
          updatedLastSelectedForShiftKey = allEntities?.[newIndex]
          if (updatedLastShiftStartAndEndIndex) {
            updatedLastShiftStartAndEndIndex.startIndex = newIndex
            if (
              newIndex > updatedLastShiftStartAndEndIndex.endIndex &&
              !flagForUpdatingEndIndex
            ) {
              updatedLastShiftStartAndEndIndex.endIndex = null
            }
          }
        }
      }
      this.setSelectedChipsAsPerSide(
        isRightSideSelection,
        updatedSelectionArray,
        updatedLastSelectedForShiftKey,
        updatedLastShiftStartAndEndIndex
      )
    }
    this.isWindowSelectMouseClick = true
  }

  @action
  handleChipsSelectionByMouseDrag = (
    entitiesToBeSelected,
    isRightHandSideOperation = false
  ) => {
    if (entitiesToBeSelected?.length) {
      let updatedSelectionArray = isRightHandSideOperation
        ? this.rightSideSelectedChipsForDrag
        : this.selectedChipsForDrag
      const removeAlreadySelected = filter(entitiesToBeSelected, ele => {
        return !find(updatedSelectionArray, selected => selected?.Id === ele?.Id)
      })
      const temp = [...updatedSelectionArray, ...removeAlreadySelected]
      updatedSelectionArray = temp
      this.isWindowSelectMouseClick = true
      if (isRightHandSideOperation) {
        this.rightSideSelectedChipsForDrag = updatedSelectionArray
      } else {
        this.selectedChipsForDrag = updatedSelectionArray
      }
    }
    this.setIsWindowSelectionGoingOn(false)
  }

  @action
  handleChipsDeselection = (isRightHandSideOperation = false) => {
    if (this.isWindowSelectMouseClick) {
      this.isWindowSelectMouseClick = false
    } else {
      this.setSelectedChipsAsPerSide(isRightHandSideOperation, [], null, null)
    }
  }

  @action
  showClusterStatuses = (product, tagId, element, isFromBulkPopup?) => {
    this.buyingSessionProductId = product?.productId ?? product?.node?.Id
    const assortmentProduct = find(product?.clusterAssortmentProducts, [
      'assortment.clusters.Id',
      tagId
    ])
    this.clusterAndEle = {
      tagId,
      element,
      currentStatus: assortmentProduct?.clusterStatus,
      assortmentProductId: assortmentProduct?.Id,
      isFromBulkPopup
    }
  }

  @action
  upsertBSPClusterStatus = async (
    assortmentProduct: string,
    ClusterStatus: { Id: string; Name: string },
    clusterId: string,
    isFromBulkPopup?: boolean
  ) => {
    const bulkTabEntity = this.bulkOpSelectedEntities?.[this.bulkOpSelectedTab]?.find(
      entity => entity?.Id === clusterId
    )
    if (bulkTabEntity) {
      bulkTabEntity.clusterStatus = ClusterStatus.Name
      bulkTabEntity.clusterStatusId = ClusterStatus.Id
    }
    if (isFromBulkPopup) {
      // Do not fire API call utill save button is clicked
      return
    }
    const {
      queryParams: { buyingSessionGroupId }
    } = nav
    const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${buyingSessionGroupId}/product/assignCluster`
    const body = {
      products: [this.buyingSessionProductId],
      clusterStatuses: [ClusterStatus?.Id],
      clusters: [clusterId]
    }
    const sessionURL: string = storage.getItem('access_token')
    try {
      await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${sessionURL}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      apolloClient.writeFragment({
        id: `VIPClusterAssortmentProduct:${assortmentProduct}`,
        fragment: gql`
          fragment VIPClusterAssortmentProductClusterStatus on VIPClusterAssortmentProduct {
            ClusterStatus {
              Id
              Name
            }
          }
        `,
        data: {
          ClusterStatus
        }
      })
    } catch (e) {}
  }

  @action
  setRefetch = refetch => {
    this.products = refetch
  }

  @action
  setBuyingSessionPresent = productsAvaliable => {
    this.areProductsAvaliable = productsAvaliable
  }

  @computed get retailBuyProductsLength() {
    return this.retailBuyProducts ? Object.keys(this.retailBuyProducts).length : 0
  }

  @computed get whereInputForBSPSummaryForGroup() {
    const [
      {
        queryParams: { buyingSessionGroupId }
      }
    ] = [nav]

    const isZAMUserLoggedIn = isZAM()

    const where = {
      c8__Parent__: {
        c8__Parent__: {
          Id: { operation: CriteriaOperationType.EQ, value: buyingSessionGroupId }
        }
      },
      ...(isZAMUserLoggedIn && {
        Channels: this.whereInputForChannels()
      })
    }
    return where
  }

  @action setFreeTagsEnums = freeTagsEnums =>
    Object.assign(this, {
      freeTagsEnums: filter(
        freeTagsEnums,
        freeTagsEnum => freeTagsEnum?.Description?.length
      )
    })

  filterProductsBasedOnFilterAndSearch = memoize(
    (
      products,
      searchKey: string,
      wsAppliedFilters: ISelectedFilter,
      productType: ProductTypeForSearchFilterEnum = ProductTypeForSearchFilterEnum.buyingSessionProduct,
      doorOrders: IDoorOrder[] = []
    ): VIPBuyingSessionProduct[] => {
      const {
        queryParams: { section, subview, tab, subSection, zoneId }
      } = nav
      const { rmClustersData } = counterOfferUIStore
      const { productForecastData } = productForecastUIStore
      const productsClone = cloneDeep(products)
      productsClone.forEach(product => {
        // Cluster Exclusion
        let excludedClusters = product?.clusterExclusion ?? []
        const excludedClustersByChannel = groupBy(excludedClusters, 'channel')
        product.clusterExclusion = excludedClustersByChannel?.[VIPChannel.Wholesale] ?? []
        product.retailClusterExclusion =
          excludedClustersByChannel?.[VIPChannel.Retail] ?? []
        const productId =
          (section === BuyingSessionAssortmentSection.clientAssortment ||
            section === BuyingSessionAssortmentSection.clusterAssortment ||
            section === BuyingSessionAssortmentSection.doorAssortment) &&
          tab !== ViewTabs.RTL_BUY.toLowerCase()
            ? product?.Original?.Id
            : product?.Id
        if (
          // BuyingSessionGroupNavView.Collection === view &&
          BuyingSessionGroupNavView.Overview !== subview &&
          hasUserRoles(
            PERMISSION_MAP.find(ele => VIPChannel.Retail === ele.id).allowedRoles
          ) &&
          rmClustersData
        ) {
          if (zoneId) {
            product.hasCounterOffer =
              rmClustersData?.[productId]?.clientMap?.[zoneId]?.flagProductAtClient
            // assortmnet views
            product.Original.hasCounterOffer =
              rmClustersData?.[productId]?.clientMap?.[zoneId]?.flagProductAtClient
          } else {
            product.hasCounterOffer = rmClustersData?.[productId]?.flagProduct
          }
        }
        if (this.wholesaleBuyProducts) {
          const buyData = this.wholesaleBuyProducts[productId]
          product.draftQty = buyData?.inProcessQuantity ?? 0
          product.sizedQty = buyData?.confirmedQuantity ?? 0
          product.value = buyData?.globalTotalValue ?? 0
          product.salesQty = buyData?.totalQuantity ?? 0
          if (
            subSection === ChannelSubSection.Wholesale ||
            tab === ViewTabs.DISTRIBUTION.toLowerCase()
          ) {
            product.totalDoors = buyData?.numberOfStores ?? 0
          }
        }
        if (productForecastData && tab === ViewTabs.FORECAST.toLowerCase()) {
          let zones = (productForecastData || [])
            ?.find(product => product?.id === productId)
            ?.clients?.slice()
          zones = zoneId ? zones?.filter(zone => zoneId === zone?.id) : zones
          let salesQty = 0
          forEach(zones, zone => {
            salesQty += zone.salesQuantity
          })
          product.salesQty = salesQty
        }
        if (this.retailBuyProducts) {
          let zones = this.retailBuyProducts[productId]?.clients?.slice()
          zones = zoneId ? zones?.filter(zone => zoneId === zone?.clientId) : zones
          let hasOrders = 0
          let salesQty = 0
          forEach(zones, zone => {
            hasOrders += zone.numberOfOrders
            salesQty += zone.salesQuantity
          })
          product.hasOrders = !!hasOrders
          if (tab === ViewTabs.RTL_BUY.toLowerCase()) {
            product.salesQty = salesQty
          }
        }
      })
      return this.filterProductsBasedOnFilters(
        this.filterProductsBasedOnSearch(
          this.filterProductsBasedOnExcludedClients(productsClone, productType),
          searchKey,
          productType
        ),
        wsAppliedFilters,
        doorOrders
      )
    },
    isEqual
  )

  sortProductsBasedOnSortType = memoize(
    (
      products,
      selectedSortAttribute: string,
      retailBuyProducts,
      zoneId
    ): VIPBuyingSessionProduct[] => {
      return orderBy(
        reduce(
          products,
          (acc, product) => {
            if (retailBuyProducts?.[product.Id]?.clients) {
              if (zoneId) {
                const { orderQuantity, orderValue } =
                  find(
                    retailBuyProducts[product.Id]?.clients,
                    client => client.clientId === zoneId
                  ) ?? {}
                product = {
                  ...product,
                  orderQuantity: orderQuantity ?? 0,
                  orderValue: orderValue ?? 0
                }
              } else {
                const { orderQuantity, orderValue } =
                  find(
                    retailBuyProducts[product.Id]?.clients,
                    client => client.clientName === 'GLOBAL'
                  ) ?? {}
                product = {
                  ...product,
                  orderQuantity: orderQuantity ?? 0,
                  orderValue: orderValue ?? 0
                }
              }
            }
            acc.push(product)
            return acc
          },
          []
        ),
        [selectedSortAttribute],
        ['desc']
      )
    },
    isEqual
  )

  filterProductsBasedOnExcludedClients = (
    products,
    productType: ProductTypeForSearchFilterEnum = ProductTypeForSearchFilterEnum.buyingSessionProduct
  ): VIPBuyingSessionProduct[] => {
    const [
      {
        queryParams: { clientId, orderType }
      }
    ] = [nav]
    return orderType
      ? filter(products, product => {
          let buyingSessionProduct
          if (productType === ProductTypeForSearchFilterEnum.assortmentProduct) {
            buyingSessionProduct = product.Original
          } else if (productType === ProductTypeForSearchFilterEnum.orderProduct) {
            buyingSessionProduct = {
              Original: product.Original,
              ...(product.BuyingSessionProduct ?? {})
            }
          } else {
            buyingSessionProduct = product
          }
          return !find(
            buyingSessionProduct?.clientExclusion,
            client => client.Id === clientId
          )
        })
      : products
  }

  filterProductsBasedOnSearch = (
    products,
    searchKeyFromStore: string,
    productType: ProductTypeForSearchFilterEnum = ProductTypeForSearchFilterEnum.buyingSessionProduct
  ): VIPBuyingSessionProduct[] => {
    const searchKeyLowerCase = searchKeyFromStore?.toLowerCase()?.trim()
    if (searchKeyLowerCase) {
      const attributesToSearch = filter(
        config?.appConfig?.attributes?.VIPProduct ?? [],
        attr => attr.includeForSearch
      )
      return filter(products, product => {
        let buyingSessionProduct
        if (productType === ProductTypeForSearchFilterEnum.assortmentProduct) {
          buyingSessionProduct = product.Original
        } else if (productType === ProductTypeForSearchFilterEnum.orderProduct) {
          buyingSessionProduct = {
            Original: product.Original,
            ...(product.BuyingSessionProduct ?? {})
          }
        } else {
          buyingSessionProduct = product
        }
        return (
          some(attributesToSearch, attribute => {
            switch (attribute.valueType) {
              case AttributeValueType.STRING:
              case AttributeValueType.ENUM:
                if (
                  includes(
                    (
                      buyingSessionProduct.Original?.[attribute.attributeName] ?? ''
                    ).toLowerCase(),
                    searchKeyLowerCase
                  )
                ) {
                  return true
                }
                break

              case AttributeValueType.REF:
                if (
                  includes(
                    (
                      buyingSessionProduct.Original?.[attribute.attributeName]?.[
                        attribute.pathToValue
                      ] ?? ''
                    ).toLowerCase(),
                    searchKeyLowerCase
                  )
                ) {
                  return true
                }
                break

              case AttributeValueType.REFLIST:
                if (
                  some(
                    buyingSessionProduct.Original?.[attribute.attributeName] ?? [],
                    reflistItem =>
                      includes(
                        (reflistItem?.pathToValue ?? '').toLowerCase(),
                        searchKeyLowerCase
                      )
                  )
                ) {
                  return true
                }
                break
            }
            return false
          }) ||
          // Clusters
          some(
            buyingSessionProduct.clusterAssortmentsProduct ?? [],
            clusterAssortmentProduct =>
              includes(
                (
                  clusterAssortmentProduct?.assortment?.clusters?.Name ?? ''
                ).toLowerCase(),
                searchKeyLowerCase
              )
          ) ||
          // Channels
          some(buyingSessionProduct.channels ?? [], channel =>
            includes((channel ?? '').toLowerCase(), searchKeyLowerCase)
          ) ||
          // Drop
          includes(
            (buyingSessionProduct.drop?.Name ?? '').toLowerCase(),
            searchKeyLowerCase
          ) ||
          // Free Tags
          // wholesale Free Tags
          some(buyingSessionProduct.retailFreeTags ?? [], tag =>
            includes((tag?.name ?? '').toLowerCase(), searchKeyLowerCase)
          ) ||
          // retail Free Tags
          some(buyingSessionProduct.wholesaleFreeTags ?? [], tag =>
            includes((tag?.name ?? '').toLowerCase(), searchKeyLowerCase)
          )
        )
      })
    }
    return products
  }

  /**
   *
   * @param product : {VIPOrderProduct}
   * @param withQty : Boolean
   * @param isBooked : Boolean
   */
  sizedQtyAndBookedUnbookedFilter = (
    product: VIPOrderProduct,
    withQty: boolean,
    isBooked: boolean
  ) => {
    if (product?.sizes?.length) {
      return withQty
        ? some(product?.qtyPerSize, qty => qty > 0) && product?.isBooked === isBooked
        : every(product?.qtyPerSize, qty => qty === 0) && product?.isBooked === isBooked
    } else {
      return (
        (withQty ? product?.totalQty > 0 : product?.totalQty === 0) &&
        product?.isBooked === isBooked
      )
    }
  }

  @computed get productsWithComment() {
    const cmComments = []
    const rmComments = []
    Object.keys(this.retailBuyComments || {}).forEach(zoneId => {
      Object.keys(this.retailBuyComments[zoneId]).forEach(productId => {
        if (this.retailBuyComments[zoneId]?.[productId]?.CM) {
          cmComments.push(productId)
        }
        if (this.retailBuyComments[zoneId]?.[productId]?.RM) {
          rmComments.push(productId)
        }
      })
    })
    return { cmComments, rmComments }
  }

  filterProductsBasedOnFilters = (
    products,
    wsAppliedFilters,
    doorOrders?: any
  ): VIPBuyingSessionProduct[] | any => {
    const {
      nav: {
        queryParams: { assortmentType, tab }
      },
      wholesaleAddProductToAssortment: { isAddProductDrawerOpen }
    } = stores
    if (!isEmpty(wsAppliedFilters)) {
      return filter(products, currentProduct => {
        let product
        if (
          assortmentType &&
          tab !== ViewTabs.RTL_BUY.toLowerCase() &&
          !isAddProductDrawerOpen
        ) {
          product = currentProduct.Original
        } else {
          product = currentProduct
        }
        return every(keys(wsAppliedFilters), appliedFilterKey => {
          const filterValueObject: IFilter = wsAppliedFilters[appliedFilterKey]
          const filterValues = filterValueObject.values ?? []
          if (!filterValues.length) {
            return true
          }
          if (filterValueObject.isVIPProductAttribute) {
            switch (filterValueObject.type) {
              case AttributeValueType.STRING:
              case AttributeValueType.ENUM:
                return some(
                  filterValues,
                  filterValue =>
                    filterValue.value === product.Original?.[appliedFilterKey]
                )

              case AttributeValueType.BOOLEAN:
                return some(
                  filterValues,
                  filterValue =>
                    filterValue.value === product.Original?.[appliedFilterKey]
                )

              case AttributeValueType.REF:
                return some(
                  filterValues,
                  filterValue =>
                    filterValue.value ===
                    product.Original?.[appliedFilterKey]?.[filterValueObject.pathToValue]
                )
            }
          } else {
            // Check filter key is ending with Cluster to filter both wholesale and retail cluster at once since property
            // is same
            if (endsWith(appliedFilterKey, 'Cluster')) {
              return some(
                filterValues,
                filterValue =>
                  (filterValue.value &&
                    some(
                      product.clusterAssortmentsProduct ?? [],
                      clusterAssortmentProduct =>
                        clusterAssortmentProduct.assortment?.clusters?.Id ===
                        filterValue.value
                    )) ||
                  (!filterValue.value &&
                    (!product.clusterAssortmentsProduct ||
                      !product.clusterAssortmentsProduct.length))
              )
            }
            // Check filter key is ending with Free Tag to filter both wholesale and retail tag at once since property
            // is same
            if (endsWith(appliedFilterKey, 'FreeTag')) {
              const tags = concat(
                product?.wholesaleFreeTags ?? [],
                product?.retailFreeTags ?? []
              )
              return some(
                filterValues,
                filterValue =>
                  (filterValue.value &&
                    some(tags, tag => tag?.Id === filterValue.value)) ||
                  (!filterValue.value && !tags?.length)
              )
            }
            switch (appliedFilterKey) {
              case FilterKeys.Drop:
                return some(
                  filterValues,
                  filterValue =>
                    filterValue &&
                    filterValue.value ===
                      (product?.[appliedFilterKey]?.Name ??
                        product?.BuyingSessionProduct?.[appliedFilterKey]?.Name)
                )

              case FilterKeys.RetailSalesPeriod:
                return some(
                  filterValues,
                  filterValue =>
                    filterValue &&
                    filterValue.value ===
                      (product?.[appliedFilterKey]?.Name ??
                        product?.BuyingSessionProduct?.[appliedFilterKey]?.Name)
                )

              case FilterKeys.Channel:
                return some(
                  filterValues,
                  filterValue =>
                    (filterValue.value &&
                      includes(product?.[appliedFilterKey] ?? [], filterValue.value)) ||
                    (!filterValue.value && !(product?.[appliedFilterKey] ?? []).length)
                )

              case FilterKeys.Looks:
                return (
                  product?.Original?.[appliedFilterKey]?.length &&
                  some(
                    filterValues,
                    filterValue =>
                      filterValue &&
                      some(
                        product.Original[appliedFilterKey],
                        look => look.Id === filterValue.value
                      )
                  )
                )
              case FilterKeys.BookedUnbooked: {
                return some(filterValues, filterValue =>
                  some(doorOrders, door => {
                    /**
                     * FIXME: RM - This logic is really bad and very easy to break. Refactor it on priority after first
                     * today's release
                     */
                    return some(door?.OrderLineItems, orderItem => {
                      if (
                        filterValue.value === FilterKeys.Booked &&
                        orderItem?.Original?.Id === product?.Original?.Id
                      ) {
                        if (
                          wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values
                            ?.length !== 2 &&
                          some(wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values, [
                            'value',
                            FilterKeys.WithoutQty
                          ])
                        ) {
                          return this.sizedQtyAndBookedUnbookedFilter(
                            orderItem,
                            false,
                            true
                          )
                        }
                        if (
                          wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values
                            ?.length !== 2 &&
                          some(wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values, [
                            'value',
                            FilterKeys.WithQty
                          ])
                        ) {
                          return this.sizedQtyAndBookedUnbookedFilter(
                            orderItem,
                            true,
                            true
                          )
                        }
                        return orderItem?.isBooked
                      } else if (
                        filterValue.value === FilterKeys.Unbooked &&
                        orderItem?.Original?.Id === product?.Original?.Id
                      ) {
                        if (
                          wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values
                            ?.length !== 2 &&
                          some(wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values, [
                            'value',
                            FilterKeys.WithoutQty
                          ])
                        ) {
                          return this.sizedQtyAndBookedUnbookedFilter(
                            orderItem,
                            false,
                            false
                          )
                        }
                        if (
                          wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values
                            ?.length !== 2 &&
                          some(wsAppliedFilters?.[FilterKeys.WithQtyWithoutQty]?.values, [
                            'value',
                            FilterKeys.WithQty
                          ])
                        ) {
                          return this.sizedQtyAndBookedUnbookedFilter(
                            orderItem,
                            true,
                            false
                          )
                        }
                        return orderItem?.isBooked === false
                      }
                    })
                  })
                )
              }
              case FilterKeys.WithQtyWithoutQty: {
                return some(filterValues, filterValue =>
                  some(doorOrders, door => {
                    return some(door?.OrderLineItems, orderItem => {
                      if (orderItem?.Original?.Id === product?.Original?.Id) {
                        if (filterValue.value === FilterKeys.WithQty) {
                          if (
                            wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values
                              ?.length !== 2 &&
                            some(wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values, [
                              'value',
                              FilterKeys.Booked
                            ])
                          ) {
                            return this.sizedQtyAndBookedUnbookedFilter(
                              orderItem,
                              true,
                              true
                            )
                          } else if (
                            wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values
                              ?.length !== 2 &&
                            some(wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values, [
                              'value',
                              FilterKeys.Unbooked
                            ])
                          ) {
                            return this.sizedQtyAndBookedUnbookedFilter(
                              orderItem,
                              true,
                              false
                            )
                          }
                          if (orderItem?.sizes?.length) {
                            return some(orderItem?.qtyPerSize, qty => qty > 0)
                          } else {
                            return orderItem?.totalQty > 0
                          }
                        } else if (filterValue.value === FilterKeys.WithoutQty) {
                          if (
                            wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values
                              ?.length !== 2 &&
                            some(wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values, [
                              'value',
                              FilterKeys.Booked
                            ])
                          ) {
                            return this.sizedQtyAndBookedUnbookedFilter(
                              orderItem,
                              false,
                              true
                            )
                          } else if (
                            wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values
                              ?.length !== 2 &&
                            some(wsAppliedFilters?.[FilterKeys.BookedUnbooked]?.values, [
                              'value',
                              FilterKeys.Unbooked
                            ])
                          ) {
                            return this.sizedQtyAndBookedUnbookedFilter(
                              orderItem,
                              false,
                              false
                            )
                          }
                          if (orderItem?.sizes?.length) {
                            return every(orderItem?.qtyPerSize, qty => qty === 0)
                          } else {
                            return orderItem?.totalQty === 0
                          }
                        }
                      }
                    })
                  })
                )
              }
              case FilterKeys.Status:
                return (
                  product?.Original &&
                  some(
                    filterValues,
                    filterValue => product.Original.Active === filterValue.value
                  )
                )

              case FilterKeys.SalesQty:
                const productToConsider =
                  assortmentType === BuyingSessionAssortmentType.client
                    ? currentProduct
                    : product
                const sizedQty = !isNaN(productToConsider.sizedQty)
                  ? toNumber(productToConsider.sizedQty)
                  : 0
                const draftQty = !isNaN(productToConsider.draftQty)
                  ? toNumber(productToConsider.draftQty)
                  : 0
                const salesQty =
                  tab === ViewTabs.RTL_BUY.toLowerCase() ||
                  tab === ViewTabs.FORECAST.toLowerCase()
                    ? productToConsider.salesQty
                    : sizedQty + draftQty
                return some(
                  filterValues,
                  filterValue =>
                    (filterValue.value && salesQty > 0) ||
                    (!filterValue.value && salesQty === 0)
                )

              case FilterKeys.Rating:
                return some(
                  filterValues,
                  filterValue =>
                    (filterValue.value && product.averageRating > 0) ||
                    (!filterValue.value && product.averageRating === 0)
                )

              case FilterKeys.ProductStatus:
                let returnValue = some(
                  filterValues,
                  filterValue => product.isCore === filterValue.value
                )
                return returnValue

              case FilterKeys.Flagged:
                return some(
                  filterValues,
                  filterValue => product.hasCounterOffer === filterValue.value
                )

              case FilterKeys.ProductOrderStatus:
                return some(
                  filterValues,
                  filterValue => product.hasOrders === filterValue.value
                )

              case FilterKeys.ProductComment:
                return some(filterValues, filterValue =>
                  filterValue.value
                    ? includes(this.productsWithComment?.cmComments, product.Id)
                    : includes(this.productsWithComment?.rmComments, product.Id)
                )
              case FilterKeys.Favourite:
                return some(
                  filterValues,
                  filterValue =>
                    (filterValue.value && (product.Favorites ?? []).length > 0) ||
                    (!filterValue.value &&
                      (!product.Favorites || !product.Favorites.length))
                )
            }
          }
          return false
        })
      })
    }
    return products
  }

  @computed get whereInputForBSPSummaryForBS() {
    const {
      queryParams: { buyingSession }
    } = nav

    const isZAMUserLoggedIn = isZAM()

    const where = {
      c8__Parent__: {
        Id: { operation: CriteriaOperationType.EQ, value: buyingSession }
      },
      ...(isZAMUserLoggedIn && {
        Channels: this.whereInputForChannels()
      })
    }

    return where
  }

  /**
   * Computed map for list view column headers for different tabs
   */
  getListViewColumnDefinitionMap = computedFn((zoneColumnMap?) => {
    return {
      [ViewTabs.DISTRIBUTION]:
        collectionListViewDefinitionService.buildListViewDefinitionForDistribution(
          ChannelSubSection.Wholesale
        ),
      [ViewTabs.RTL_DISTRIBUTION]:
        collectionListViewDefinitionService.buildListViewDefinitionForDistribution(
          ChannelSubSection.Retail
        ),
      [ViewTabs.FORECAST]:
        collectionListViewDefinitionService.buildListViewDefinitionForForecast(),
      [ViewTabs.BUY]: collectionListViewDefinitionService.buildListViewDefinitionForBuy(
        ChannelSubSection.Wholesale
      ),
      [ViewTabs.RTL_BUY]:
        collectionListViewDefinitionService.buildListViewDefinitionForBuy(
          ChannelSubSection.Retail
        ),
      ...(zoneColumnMap
        ? {
            [ViewTabs.COUNTER_OFFER]:
              collectionListViewDefinitionService.buildListViewDefinitionForCounterOffer(
                zoneColumnMap
              )
          }
        : {})
    }
  })

  /**
   * Computed map for kpi view column headers for different tabs
   */
  @computed get kpiViewColumnDefinitionMap() {
    return {
      [ViewTabs.FORECAST]:
        collectionKpiViewDefinitionService.buildKpiViewDefinitionForForecast(),
      [ViewTabs.RTL_BUY]:
        collectionKpiViewDefinitionService.buildKpiViewDefinitionForBuy()
    }
  }

  /**
   * Sync list view tab changes to nav store
   * @param tab - list view tab name
   */
  onListViewTabChangeHandler = (tab: string) => {
    const {
      nav: { updateQueryParams },
      filterModalStore: { onFilterClear }
    } = stores

    onFilterClear(null)
    updateQueryParams({
      tab: tab.toLocaleLowerCase()
    })
  }

  /**
   * where input for wholesale channel check
   */
  whereInputForChannels = () => {
    const wholesaleChannelValue =
      config.appConfig?.enumerations?.channel?.VALUES?.WHOLESALE
    return {
      operation: CriteriaOperationType.EQ,
      value: wholesaleChannelValue
    }
  }

  /**
   * Method for building where input for buying session products query for buying session group
   * @param {string} activity - Name of activity
   * @param {Array<string>} childrenMeta - ChildrenMeta for given activity
   * @param {Array<string>} childrenMetaValues - Values for hierarchy chilren
   * @returns Where input object for buying session products query for given group
   */
  whereInputForBSPForGroup = (
    activity: string,
    childrenMeta: Array<string>,
    childrenMetaValues: Array<string>
  ) => {
    let baseInputForQuery: any = cloneDeep(this.whereInputForBSPSummaryForGroup)

    baseInputForQuery.Original = wholesaleCollectionService.buildAttributeHierarchyQuery(
      activity,
      childrenMeta,
      childrenMetaValues
    )
    return baseInputForQuery
  }

  /**
   * Method for building where input for buying session products query for buying session
   * @param {string} activity - Name of activity
   * @param {Array<string>} childrenMeta - ChildrenMeta for given activity
   * @param {Array<string>} childrenMetaValues - Values for hierarchy chilren
   * @returns Where input object for buying session products query for given buying session
   */
  whereInputForBSPForBS = (
    activity: string,
    childrenMeta: Array<string>,
    childrenMetaValues: Array<string>
  ) => {
    let baseInputForQuery: any = cloneDeep(this.whereInputForBSPSummaryForBS)

    baseInputForQuery.Original = wholesaleCollectionService.buildAttributeHierarchyQuery(
      activity,
      childrenMeta,
      childrenMetaValues
    )
    return baseInputForQuery
  }
  /**
   * To get product attribute
   * @param {object} product
   * @returns {boolean}
   */
  getAttribute = (attributes, attributeNameEnum) => {
    return find(attributes, attribute => attribute.name === attributeNameEnum) || []
  }
  /**
   * To check duplicate tag on product
   *
   * @param {object} product
   * @param {string} tagId
   * @param {string} attrubuteEnum
   * @returns {boolean}
   */
  checkDuplicateTag = (buyingSessionProduct, tagId, attribute) => {
    const attributes = this.getAttribute(buyingSessionProduct.attributes, attribute)
    return attributes?.value?.length
      ? attributes.value.some(attr => attr.id === tagId)
      : false
  }

  checkIsClusterExcluded = ({ attributes }, tagId: string) => {
    attributes = this.getAttribute(
      attributes,
      ProductCardAttributeEnum.wholesaleClusterExclusion
    )
    return attributes?.value?.length && attributes.value.some(elem => elem.id === tagId)
  }

  /**
   * To check channel tag present on product
   * @param {object} product
   * @returns {boolean}
   */
  hasChannelTagOnProduct = (buyingSessionProduct, channel) => {
    const channels = this.getAttribute(
      buyingSessionProduct.attributes,
      ProductCardAttributeEnum.channels
    )
    const allChannels = map(channels.value, 'id')
    return allChannels.length && allChannels?.includes(channel)
  }

  /**
   * Listview Wrapper around handleTagDrop
   */
  handleListViewTagDrop =
    (buyingSessionProduct, t: WithTranslationProps['i18n']['t']) =>
    ({ id, type }) => {
      this.handleTagDrop(buyingSessionProduct, type, id, t)
    }
  /**
   * Handler for tag drop on product
   *
   * @param {object} processedProduct - Massaged product, can be either buying session product or assortment product
   * @param {string} type
   * @param {string} tagId
   */
  @action handleTagDrop = async (
    processedProduct: IGridViewProduct,
    type,
    tagId,
    t: WithTranslationProps['i18n']['t']
  ) => {
    let {
      nav: { queryParams }
    } = stores

    const isAssortmentView = !!queryParams.assortmentType
    const isBSRestricted = isBuyingSessionRestrictedForTag(
      processedProduct.buyingSession,
      type,
      tagId
    )
    const productId = processedProduct.node.Id
    let shouldBSPSync = false
    if (type === strings.tagTypes.channel) {
      const allowedRoles = PERMISSION_MAP.find(ele => ele.id === tagId)?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      if (processedProduct.isActive && !isBSRestricted) {
        const isDuplicate = this.checkDuplicateTag(
          processedProduct,
          tagId,
          ProductCardAttributeEnum.channels
        )
        if (!isDuplicate) {
          await this.addChannelToBuyingSessionProduct(productId, tagId)
          shouldBSPSync = true
        }
      } else {
        this.openMessageDialog = true
        this.displayMessage = !processedProduct.isActive
          ? t(
              'bb.common.warnings.cannotDragTagsInactiveProduct',
              'Cannot assign tags to inactive product'
            )
          : t(
              'bb.common.warnings.cannotDragTagsClosedBuyingSession',
              'Cannot assign tags to product within closed buying session'
            )
      }
    } else if (type === strings.tagTypes.wholesaleCluster && !isAssortmentView) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Wholesale
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      // Prevent Excluded Cluster From Getting Added as Wholesale Cluster
      if (this.checkIsClusterExcluded(processedProduct, tagId)) return
      const isChannelPresentOnProduct = this.hasChannelTagOnProduct(
        processedProduct,
        VIPChannel.Wholesale
      )
      if (!isBSRestricted && isChannelPresentOnProduct && processedProduct.isActive) {
        const isDuplicate = this.checkDuplicateTag(
          processedProduct,
          tagId,
          ProductCardAttributeEnum.wholesaleClusters
        )
        if (!isDuplicate) {
          await this.addClusterToBuyingSessionProduct(
            queryParams.buyingSessionGroupId,
            productId,
            tagId
          )
        }
      } else {
        this.openMessageDialog = true
        if (isBSRestricted) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsClosedBuyingSession',
            'Cannot assign tags to product within closed buying session'
          )
        } else if (!processedProduct.isActive) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsInactiveProduct',
            'Cannot assign tags to inactive product'
          )
        } else {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsNoChannelOnProduct',
            'Cannot add Wholesale Cluster to product as it is not in Wholesale Channel'
          )
        }
      }
    } else if (type === strings.tagTypes.retailCluster && !isAssortmentView) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Retail
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      // Prevent Excluded Cluster From Getting Added as Retail Cluster
      if (this.checkIsClusterExcluded(processedProduct, tagId)) return
      const isChannelPresentOnProduct = this.hasChannelTagOnProduct(
        processedProduct,
        VIPChannel.Retail
      )
      if (!isBSRestricted && isChannelPresentOnProduct && processedProduct.isActive) {
        const isDuplicate = this.checkDuplicateTag(
          processedProduct,
          tagId,
          ProductCardAttributeEnum.retailClusters
        )
        if (!isDuplicate) {
          await this.addClusterToBuyingSessionProduct(
            queryParams.buyingSessionGroupId,
            productId,
            tagId
          )
        }
      } else {
        this.openMessageDialog = true
        if (isBSRestricted) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsClosedBuyingSession',
            'Cannot assign tags to product within closed buying session'
          )
        } else if (!processedProduct.isActive) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsInactiveProduct',
            'Cannot assign tags to inactive product'
          )
        } else {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragRetailTagsNoChannelOnProduct',
            'Cannot add Retail Cluster to product as it is not in Retail Channel'
          )
        }
      }
    } else if (type === strings.tagTypes.drop && !isAssortmentView) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Wholesale
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      if (processedProduct.isActive && !isBSRestricted) {
        const isDuplicate = this.checkDuplicateTag(
          processedProduct,
          tagId,
          ProductCardAttributeEnum.drop
        )
        if (!isDuplicate) {
          await this.addDropToBuyingSessionProduct(productId, tagId)
          shouldBSPSync = true
        }
      } else {
        this.openMessageDialog = true
        if (!processedProduct.isActive) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsInactiveProduct',
            'Cannot assign tags to inactive product'
          )
        } else {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsClosedBuyingSession',
            'Cannot assign tags to product within closed buying session'
          )
        }
      }
    } else if (
      type === strings.tagTypes.retailFreeTags &&
      !isAssortmentView &&
      !isBSRestricted &&
      processedProduct.isActive
    ) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Retail
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      const isDuplicate = this.checkDuplicateTag(
        processedProduct,
        tagId,
        ProductCardAttributeEnum.retailFreeTags
      )
      if (!isDuplicate) {
        await this.addFreeTagToBuyingSessionProduct(productId, tagId)
        shouldBSPSync = true
      }
    } else if (
      type === strings.tagTypes.wholesaleFreeTags &&
      !isAssortmentView &&
      !isBSRestricted &&
      processedProduct.isActive
    ) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Wholesale
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      const isDuplicate = this.checkDuplicateTag(
        processedProduct,
        tagId,
        ProductCardAttributeEnum.wholesaleFreeTags
      )
      if (!isDuplicate) {
        await this.addFreeTagToBuyingSessionProduct(productId, tagId)
        shouldBSPSync = true
      }
    } else if (
      type === strings.tagTypes.salesPeriod &&
      !isAssortmentView &&
      processedProduct.isActive
    ) {
      const allowedRoles = PERMISSION_MAP.find(
        ele => ele.id === VIPChannel.Retail
      )?.allowedRoles
      const canAdd = hasUserRoles(allowedRoles)
      if (!canAdd) return
      const isChannelPresentOnProduct = this.hasChannelTagOnProduct(
        processedProduct,
        VIPChannel.Retail
      )
      if (!isBSRestricted && isChannelPresentOnProduct && processedProduct.isActive) {
        const isDuplicate = this.checkDuplicateTag(
          processedProduct,
          tagId,
          ProductCardAttributeEnum.retailSalesPeriod
        )
        if (!isDuplicate) {
          await this.addSalesPeriodToBSP(productId, tagId)
          shouldBSPSync = true
        }
      } else {
        this.openMessageDialog = true
        if (isBSRestricted) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsClosedBuyingSession',
            'Cannot assign tags to product within closed buying session'
          )
        } else if (!processedProduct.isActive) {
          this.displayMessage = t(
            'bb.common.warnings.cannotDragTagsInactiveProduct',
            'Cannot assign tags to inactive product'
          )
        } else {
          this.displayMessage = this.displayMessage = t(
            'bb.common.warnings.cannotDragRetailSalesPeriodNoChannelOnProduct',
            'Cannot add Retail Sales Period to product as it is not in Retail Channel'
          )
        }
      }
    }
    if (shouldBSPSync) {
      syncToBsgElasticSearch([processedProduct.node.Id])
    }
  }

  @action deleteClusterAssortmentProduct = async (
    buyingSessionProduct,
    assortmentProductId
  ) => {
    this.isMutationInProgress = true
    const {
      queryParams: { assortment, assortmentType, buyingSessionGroupId, client, zoneId }
    } = nav

    try {
      const clusterId = buyingSessionProduct.clusterAssortmentProducts.find(
        assortmentProduct => assortmentProduct.Id === assortmentProductId
      ).assortment.clusters.Id
      const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${buyingSessionGroupId}/cluster/${clusterId}/product`
      const sessionURL: string = storage.getItem('access_token')
      const { data } = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${sessionURL}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        params: {
          products: buyingSessionProduct.node.Id
        }
      })
      if (
        data?.products?.length === 1 &&
        data?.products[0] === buyingSessionProduct.node.Id
      ) {
        const {
          nav: {
            queryParams: { productLayout, buyingSession }
          }
        } = stores
        const { setForecastData } = productForecastUIStore
        const promiseAll = []
        const refetchQueries = this.getRefetchQueriesForRemoveCluster(
          assortment,
          assortmentType,
          buyingSessionProduct,
          buyingSessionGroupId,
          client,
          zoneId
        )
        await this.fetchAndUpdateRetailBuyProducts(buyingSessionGroupId, buyingSession, [
          buyingSessionProduct?.id
        ])
        refetchQueries?.forEach(query => promiseAll.push(apolloClient.query(query)))
        await Promise.all(promiseAll)
        'list' === productLayout && (await setForecastData(null, true))
      }
    } finally {
      this.isMutationInProgress = false
      this.closeDeleteAssortmentProductConfirmation()
    }
  }

  @action
  removeClusterFromExcludedClusters = async (buyingSessionProduct, cluster) => {
    const bspID = buyingSessionProduct.productId
    this.isMutationInProgress = true
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: bspID
      }
    }
    try {
      await apolloClient.mutate({
        mutation: REMOVE_CLUSTER_FROM_BUYING_SESSION_PRODUCT_EXCLUSION,
        variables: {
          buyingSessionProduct: bspID,
          cluster
        },
        awaitRefetchQueries: true,
        refetchQueries: [refetchQuery]
      })
    } finally {
      this.isMutationInProgress = false
    }
  }

  @action deleteClusterFromBuyingSessionProduct = async (
    buyingSessionProduct,
    tagId,
    assortmentProductId?
  ) => {
    const assortmentProducts =
      buyingSessionProduct[WholesaleGirdProductFieldMapping.ClusterAssortmentProducts]
    // eslint-disable-next-line array-callback-return
    const clusterAssortmentProductToDelete = assortmentProducts.find(product => {
      const cluster =
        product[ProductCardAttributeEnum.assortment][ProductCardAttributeEnum.clusters]
      if (cluster?.Id === tagId) {
        return product
      }
    })

    this.deleteClusterAssortmentProduct(
      buyingSessionProduct,
      clusterAssortmentProductToDelete?.Id
    )
  }

  @action
  openDeleteAssortmentProductConfirmation = selectedClusterAssortmentProduct => e => {
    if (e.stopPropagation) e.stopPropagation()
    const {
      nav: {
        queryParams: { assortment }
      }
    } = stores
    this.showConfirmationDeleteClusterAssortmentProduct = true
    this.selectedClusterAssortmentProduct = selectedClusterAssortmentProduct
    this.selectedClusterAssortmentId =
      selectedClusterAssortmentProduct?.clusterAssortmentProducts?.find(
        assortmentProduct => assortmentProduct?.assortment?.Id === assortment
      ).Id
  }

  @action closeDeleteAssortmentProductConfirmation = () => {
    this.showConfirmationDeleteClusterAssortmentProduct = false
  }

  getRefetchQueriesForRemoveCluster = (
    assortment,
    assortmentType,
    processedBuyingSessionProduct,
    buyingSessionGroupId?: string,
    clientId?: string,
    zoneId?: string
  ) => {
    if (assortment) {
      // In case of assortment, refecth both summary as well as products on cluster remove
      const {
        wholesaleAssortmentProductStore: { whereInputForwhereInputForAssortmentProduct }
      } = stores

      // Extract hierarchy for building where object for assortment product query
      let activity =
        processedBuyingSessionProduct?.node?.Original?.Activity?.Name ?? 'Undefined'
      let childrenMeta = ACTIVITY_HIERARCHY_MAP[activity] || DEFAULT_ACTIVITY_HIERARCHY
      let childrenMetaValues = []

      childrenMeta.forEach(currentCategory => {
        childrenMetaValues.push(
          processedBuyingSessionProduct?.node?.Original?.[
            `${capitalize(currentCategory)}`
          ]?.Name
        )
      })

      const assortmentProductWhereInput = whereInputForwhereInputForAssortmentProduct(
        activity,
        childrenMeta,
        childrenMetaValues
      )

      const assortmentWhereKey =
        assortmentType === BuyingSessionAssortmentType.cluster
          ? 'VIPClusterAssortment'
          : assortmentType === BuyingSessionAssortmentType.client
          ? 'VIPClientAssortment'
          : 'VIPDoorAssortment'
      return [
        {
          query: GET_CLUSTER_ASSORTMENT_SUMMARY,
          variables: {
            buyingSessionAssortmentProductSummaryWhere: {
              GIV_VIPAssortmentProduct_Assortment_ref: {
                [assortmentWhereKey]: {
                  Id: { operation: CriteriaOperationType.EQ, value: assortment }
                }
              }
            }
          },
          fetchPolicy: 'network-only'
        },
        {
          query: WS_CLUSTER_ASSORTMENT_PRODUCTS,
          variables: {
            where: assortmentProductWhereInput
          },
          fetchPolicy: 'network-only'
        }
      ]
    } else if (assortmentType === BuyingSessionAssortmentType.client) {
      this.getAssortmentProductsByType(
        buyingSessionGroupId,
        clientId !== '' ? clientId : zoneId,
        BuyingSessionAssortmentType.client,
        null,
        true
      )
      return [
        {
          query: GET_BUYING_SESSION_PRODUCT,
          variables: {
            buyingSessionProductID: processedBuyingSessionProduct?.node?.Id
          },
          fetchPolicy: 'network-only'
        }
      ]
    } else if (assortmentType === BuyingSessionAssortmentType.door) {
      this.getAssortmentProductsByType(
        buyingSessionGroupId,
        zoneId,
        BuyingSessionAssortmentType.door,
        clientId,
        true
      )
      return [
        {
          query: GET_BUYING_SESSION_PRODUCT,
          variables: {
            buyingSessionProductID: processedBuyingSessionProduct?.node?.Id
          },
          fetchPolicy: 'network-only'
        }
      ]
    } else {
      return [
        {
          query: GET_BUYING_SESSION_PRODUCT,
          variables: {
            buyingSessionProductID: processedBuyingSessionProduct?.productId
          },
          fetchPolicy: 'network-only'
        }
      ]
    }
  }
  /**
   * Marks product exclusive to particular channel
   */
  @action addChannelToBuyingSessionProduct = async (
    buyingSessionProductId,
    channelId
  ) => {
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProductId
      }
    }
    await apolloClient.mutate({
      mutation: ADD_CHANNEL_TO_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductId,
        channelId
      },
      awaitRefetchQueries: true,
      refetchQueries: [refetchQuery]
    })
  }

  @action addClusterToBuyingSessionProduct = async (
    buyingSessionGroupId: string,
    buyingSessionProductId: string,
    clusterId: string
  ) => {
    const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${buyingSessionGroupId}/product/assignCluster`
    const body = {
      products: [buyingSessionProductId],
      clusters: [clusterId]
    }
    const sessionURL: string = storage.getItem('access_token')
    const { data } = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${sessionURL}`,
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    if (data?.errors?.length === 0 && data?.success?.length === 1) {
      const {
        nav: {
          queryParams: { productLayout, buyingSession }
        }
      } = stores
      const { setForecastData } = productForecastUIStore
      await this.fetchAndUpdateRetailBuyProducts(buyingSessionGroupId, buyingSession, [
        buyingSessionProductId
      ])
      await apolloClient.query({
        query: GET_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProductID: buyingSessionProductId
        },
        fetchPolicy: 'network-only'
      })
      'list' === productLayout && (await setForecastData(null, true))
    }
  }

  @action addDropToBuyingSessionProduct = async (buyingSessionProductId, dropId) => {
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProductId
      }
    }
    await apolloClient.mutate({
      mutation: ADD_DROP_TO_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductId,
        dropId
      },
      refetchQueries: [refetchQuery]
    })
  }

  /**
   * addFreeTagToBuyingSessionProduct
   * @param buyingSessionProductId - Product id
   * @param tag - Free tag id
   */
  @action addFreeTagToBuyingSessionProduct = async (buyingSessionProductId, tagId) => {
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProductId
      }
    }

    await apolloClient.mutate({
      mutation: WS_ADD_FREE_TAG_TO_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductId,
        tagId
      },
      awaitRefetchQueries: true,
      refetchQueries: [refetchQuery]
    })
  }

  @action handleMessageDialogClose = () => {
    this.openMessageDialog = false
    this.displayMessage = ''
  }

  @action handleConfirmationDialogClose = () => {
    this.openConfirmationDialog = false
    this.displayMessage = ''
  }

  @action
  showDeleteConfirmationDialog = (
    buyingSessionProduct = null,
    channel = null,
    t: WithTranslationProps['i18n']['t']
  ) => {
    const isBSRestricted = isBuyingSessionRestrictedForTag(
      buyingSessionProduct.buyingSession,
      strings.tagTypes.channel,
      channel
    )
    if (buyingSessionProduct.isActive && !isBSRestricted) {
      this.openConfirmationDialog = true
      this.displayMessage =
        VIPChannel.Retail === channel
          ? t(
              'bb.common.warnings.retailChannelRemovalConfirmationMessage',
              'Removing channel will also remove product from cluster, zone and store assortments. Are you sure you want to continue?'
            )
          : t(
              'bb.common.warnings.channelRemovalConfirmationMessage',
              'Removing channel will also remove product from cluster, client and door assortments. Are you sure you want to continue?'
            )
      this.displayTitle = t('bb.common.label.removeChannel', 'Remove Channel')
      this.buyingSessionProductId = buyingSessionProduct.productId
      this.tagId = channel
      this.onDeleteConfirmationClick = this.removeChannelFromBuyingSessionProduct
    } else {
      this.openMessageDialog = true
      this.displayMessage = !buyingSessionProduct.isActive
        ? t(
            'bb.common.warnings.cannotRemoveTagsInactiveProduct',
            'Cannot remove tags from inactive product'
          )
        : t(
            'bb.common.warnings.cannotRemoveTagsClosedBuyingSession',
            'Cannot remove tags from product of closed buying session'
          )
    }
  }

  @action showDropDeleteConfirmationDialog = (
    buyingSessionProduct,
    t: WithTranslationProps['i18n']['t']
  ) => {
    this.buyingSessionProductId = buyingSessionProduct?.node?.Id
    this.openConfirmationDialog = true
    this.displayMessage = t(
      'bb.common.warnings.deleteDropConfirmationMessage',
      'Are you sure you want to remove this drop?'
    )
    this.displayTitle = t('bb.common.label.removeDrop', 'Remove Drop')
    this.onDeleteConfirmationClick = this.removeDropFromBuyingSessionProduct
  }

  @action removeDropFromBuyingSessionProduct = async () => {
    const { buyingSessionProductId } = this
    this.openConfirmationDialog = false
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProductId
      }
    }
    await apolloClient.mutate({
      mutation: REMOVE_DROP_FROM_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductId
      },
      refetchQueries: [refetchQuery]
    })
    // syncing from here to maintain async sequence, since base method invokes a confirmation dialogue
    if (buyingSessionProductId) {
      syncToBsgElasticSearch([buyingSessionProductId])
    }
  }

  /**
   * Remove channel from buying session product
   */
  @action removeChannelFromBuyingSessionProduct = async () => {
    const { buyingSessionProductId, tagId } = this

    this.isDeleteInProgress = true

    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProductId
      }
    }
    try {
      await apolloClient.mutate({
        mutation: REMOVE_CHANNEL_FROM_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProductId: buyingSessionProductId,
          channel: tagId
        },
        awaitRefetchQueries: true,
        refetchQueries: [refetchQuery]
      })
      // syncing from here to maintain async sequence, since base method invokes a confirmation dialogue
      if (buyingSessionProductId) {
        syncToBsgElasticSearch([buyingSessionProductId])
      }
      // Product is not present in an Order → Admin/CM removes channel from product card in BB → on Add Product page →
      // this product should not be visible (Same as Inactive product use case) -
    } finally {
      this.isDeleteInProgress = false
      this.handleConfirmationDialogClose()
      this.onDeleteConfirmationClick = null
    }
  }

  @action removeZoneExclusionFromBuyingSessionProduct = async (
    buyingSessionProduct,
    tagId
  ) => {
    const {
      node: { Id }
    } = buyingSessionProduct

    if (Id && tagId) {
      const { data } = await addOrRemoveClientExclusion(Id, {
        addClients: [],
        removeClients: [tagId]
      })
      if (data?.status === 'Success') {
        await apolloClient.query({
          query: GET_BUYING_SESSION_PRODUCT_DETAILS,
          variables: {
            where: {
              Id: {
                operation: CriteriaOperationType.EQ,
                value: Id
              }
            }
          },
          fetchPolicy: 'network-only'
        })
      }
    }
  }

  /**
   * removeFreeTagFromBuyingSessionProduct
   * @param buyingSessionProductId - Product id
   * @param tag - Free tag id
   */
  @action removeFreeTagFromBuyingSessionProduct = async (buyingSessionProduct, tagId) => {
    const {
      node: { Id }
    } = buyingSessionProduct
    if (!isEmpty(Id)) {
      const refetchQuery = {
        query: GET_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProductID: Id
        }
      }
      await apolloClient.mutate({
        mutation: WS_REMOVE_FREE_TAG_TO_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProductId: Id,
          tagId
        },
        awaitRefetchQueries: true,
        refetchQueries: [refetchQuery]
      })
    }
  }

  /**
   * removeSalesPeriodFromBuyingSessionProduct
   * @param buyingSessionProduct - Product id
   */
  @action removeSalesPeriodFromBuyingSessionProduct = async buyingSessionProduct => {
    const {
      node: { Id }
    } = buyingSessionProduct
    if (!isEmpty(Id)) {
      const refetchQuery = {
        query: GET_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProductID: Id
        }
      }
      await apolloClient.mutate({
        mutation: REMOVE_SALES_PERIOD_FROM_BUYING_SESSION_PRODUCT,
        variables: {
          buyingSessionProduct: Id
        },
        awaitRefetchQueries: true,
        refetchQueries: [refetchQuery]
      })
    }
  }

  @action
  closeProductDetail = () => {
    const {
      setQueryParams,
      location: { search }
    } = nav
    let qsJSON: any = cloneDeep(qs.parse(search))
    if (qsJSON.bspId) {
      delete qsJSON.bspId
    } else if (qsJSON.productId) {
      delete qsJSON.productId
    }
    setQueryParams(qsJSON)
  }

  /**
   * Sync list view tab changes to nav store
   * @param tab - list view tab name
   */
  getImage = Images => {
    const image = Images ? getDefaultImage(Images) : null
    const imageId = image?.Value?.Id ?? null
    const imageURL = imageId
      ? getMediaCentricURI({
          URL: imageId,
          Attribute: ImageAttributes.SmallImage,
          Module: Modules.Publisher,
          Operation: Operations.GetFromNode
        })
      : null
    return imageURL
  }

  @action favoriteClickHandler = buyingSessionProductId => async event => {
    if (!event.shiftKey) {
      event.stopPropagation()
      const refetchQuery = {
        query: GET_BUYING_SESSION_PRODUCT_DETAILS,
        variables: {
          where: {
            Id: { operation: CriteriaOperationType.EQ, value: buyingSessionProductId }
          }
        }
      }
      await apolloClient.mutate({
        mutation: WS_TOGGLE_FAVORITE_FLAG_FOR_BS_PRODUCT,
        variables: {
          buyingSessionProductId
        },
        refetchQueries: [refetchQuery]
      })
    }
  }

  getTabsForView = computedFn(
    (channels, zoneColumnMap?, excludedBSGStatuses?: string[]) => {
      const {
        nav: {
          queryParams: { tab, productLayout, subview: subView = '' }
        }
      } = stores
      let tabList = []
      let selectedTab
      let tabColDefinition
      if (productLayout === strings.list) {
        tabList = getViewTabsToRender({
          view: strings.list,
          viewType: 'collection',
          channels,
          subView,
          excludedBSGStatuses
        })
        selectedTab = tab ? decodeURIComponent(tab).toUpperCase() : ViewTabs.DISTRIBUTION
        tabColDefinition = this.getListViewColumnDefinitionMap(zoneColumnMap)[selectedTab]
      }
      if (productLayout === strings.kpi) {
        tabList = getViewTabsToRender({
          view: strings.kpi,
          viewType: 'collection',
          channels,
          subView
        })
        selectedTab = tab ? decodeURIComponent(tab).toUpperCase() : ViewTabs.FORECAST
        tabColDefinition = this.kpiViewColumnDefinitionMap[selectedTab]
      }
      return {
        tabList,
        selectedTab,
        tabColDefinition
      }
    }
  )

  @action
  fetchBuyKPIs = async (buyingSessionGroupId, buyingSessionId, clientId?, doorId?) => {
    this.isKPIDataLoading = true
    try {
      const [kpiData, buyKpiData] = await Promise.all([
        ProductForecastKPIsService.getProductForecastKPIs(
          buyingSessionGroupId,
          buyingSessionId,
          clientId
        ),
        ProductForecastKPIsService.getBuyKPIsForRetail(
          buyingSessionGroupId,
          buyingSessionId,
          clientId,
          doorId
        )
      ])

      this.productForecastKPIData = kpiData
      this.productBuyKPIData = buyKpiData
    } catch (e) {
      console.log(e)
    } finally {
      this.isKPIDataLoading = false
    }
  }

  @action
  fetchRetailBuyProducts = (
    buyingSessionGroupId,
    buyingSessionId,
    clientId?,
    doorId?
  ) => {
    Promise.all([
      this.syncBuyTargetService.getRetailBuyProducts(
        buyingSessionGroupId,
        buyingSessionId,
        clientId,
        doorId
      ),
      this.commentService.getComments(buyingSessionGroupId, clientId)
    ])
      .then(([retailBuyData, retailBuyComments]) => {
        this.retailBuyProducts = retailBuyData
        this.retailBuyComments = retailBuyComments
      })
      .catch(e => {
        console.log(e)
      })
  }

  @action
  fetchAndUpdateRetailBuyProducts = (
    buyingSessionGroupId,
    buyingSessionId,
    productIds,
    clientId?,
    doorId?
  ) => {
    this.syncBuyTargetService
      .getRetailBuyProducts(buyingSessionGroupId, buyingSessionId, clientId, doorId)

      .then(retailBuyData => {
        const oldRetailBuyProducts = cloneDeep(this.retailBuyProducts)
        productIds.forEach(id => {
          if (oldRetailBuyProducts[id]) {
            oldRetailBuyProducts[id].clients = retailBuyData[id]?.clients
          }
        })
        this.retailBuyProducts = oldRetailBuyProducts
      })
      .catch(e => {
        console.error(e)
      })
  }

  @action
  updateRetailBuyComment = (
    buyingSessionProductId: string,
    clientId: string,
    comments: string,
    commentType: string
  ) => {
    const {
      queryParams: { buyingSessionGroupId }
    } = nav
    this.commentService
      .updateComment(buyingSessionGroupId, buyingSessionProductId, clientId, {
        comments,
        commentType
      })
      .then(res => {
        if (res.status === 200) {
          this.retailBuyComments = this.retailBuyComments || {}
          this.retailBuyComments[clientId] = {
            ...(this.retailBuyComments[clientId] || {}),
            [buyingSessionProductId]: {
              ...(this.retailBuyComments[clientId]?.[buyingSessionProductId] || {}),
              CM: comments
            }
          }
        }
      })
      .catch(e => {
        console.error(e)
      })
  }

  @action
  fetchWHLBuyProducts = async (
    buyingSessionGroupId,
    buyingSessionId,
    clientId?,
    doorId?
  ) => {
    try {
      this.syncBuyTargetService
        .getWholesaleBuyProducts(buyingSessionGroupId, buyingSessionId, clientId, doorId)
        .then(response => {
          this.wholesaleBuyProducts = response
        })
        .catch(e => {
          console.log(e)
        })
    } catch (e) {
      console.log(e)
    }
  }

  @action
  resetBulkOpSelectedProducts = (evt?) => {
    if (evt?.preventDefault) {
      evt.preventDefault()
    }
    if (this.productSelectionStore.countOfBulkActionSelectedProducts) {
      this.productSelectionStore.resetBulkActionSelectedProducts()
      Object.assign(this, {
        bulkOpProductsCountWithoutWholesaleChannel: 0,
        bulkOpProductsCountFromClosedBS: 0,
        bulkOpProductsCountWithoutRetailChannel: 0,
        bulkOpCoreProductsCount: 0
      })
    }
  }

  @action rightClickHandlerForBulkOp = evt => {
    const {
      nav: {
        queryParams: { assortmentType }
      }
    } = stores
    evt.preventDefault()
    if (this.productSelectionStore.countOfBulkActionSelectedProducts && !assortmentType) {
      this.isBulkOpPopupDisplayed = true
    }
  }

  @action showBulkOpPopupOnTagProductsClick = () => {
    if (this.productSelectionStore.countOfBulkActionSelectedProducts) {
      this.isBulkOpPopupDisplayed = true
    }
  }

  @action hideBulkOpPopupAndResetSelections = () => {
    Object.assign(this, {
      isBulkOpPopupDisplayed: false,
      bulkOpSelectedEntities: {},
      bulkOpSelectedTab: strings.tagTypes.channel,
      selectedChipsForDrag: [],
      lastSelectedForShiftKey: null,
      lastShiftStartAndEndIndex: null,
      isWindowSelectionGoingOn: false,
      rightSideSelectedChipsForDrag: [],
      rightSideLastSelectedForShiftKey: null,
      rightSideLastShiftStartAndEndIndex: null
    })
  }

  @action mouseDownHandlerForBSProducts = product => event => {
    if (event.shiftKey) {
      this.handleBulkOpProductSelection(event, product)
    }
  }

  @action
  handleBulkOpProductSelection = (e, product) => {
    const {
      nav: {
        queryParams: { assortmentType }
      }
    } = stores
    e.preventDefault()
    if (assortmentType) {
      return
    }
    const highestUser = getHighestUser()
    const highestUserRoleName = highestUser?.[0]?.name ?? ''
    const wholesaleChannelValue =
      config.appConfig?.enumerations?.channel?.VALUES?.WHOLESALE
    const retailChannelValue = VIPChannel.Retail
    const hasWholesaleChannel = product.attributes.some(
      attribute =>
        attribute.name === ProductCardAttributeEnum.channels &&
        attribute.value.find(({ id }) => id === wholesaleChannelValue)
    )
    const hasRetailChannel = product.attributes.some(
      attribute =>
        attribute.name === ProductCardAttributeEnum.channels &&
        attribute.value.find(({ id }) => id === retailChannelValue)
    )
    const isProductFromClosedBS =
      product?.buyingSession?.Status ===
        config?.appConfig?.enumerations?.buyingSessionStatus?.BUYING_SESSION_STATUS_VALUES
          .CLOSED &&
      product?.buyingSession?.STD_RTLBuyingSession_Status ===
        config?.appConfig?.enumerations?.retailBuyingSessionStatus
          ?.BUYING_SESSION_STATUS_VALUES.CLOSED

    if (!this.productSelectionStore.isProductSelected(product.productId)) {
      if (
        product.isActive &&
        this.productSelectionStore.countOfBulkActionSelectedProducts <
          this.productSelectionStore.MAX_SELECTION_LIMIT &&
        highestUserRoleName !== UserRoles.ZONE_AREA_MANAGER
      ) {
        this.productSelectionStore.addToBulkActionSelectedProducts(product.productId)
        if (!hasWholesaleChannel) {
          this.bulkOpProductsCountWithoutWholesaleChannel++
        }
        if (isProductFromClosedBS) {
          this.bulkOpProductsCountFromClosedBS++
        }
        if (!hasRetailChannel) {
          this.bulkOpProductsCountWithoutRetailChannel++
        }
        if (product.isCore) {
          this.bulkOpCoreProductsCount++
        }
      }
    } else {
      this.productSelectionStore.removeFromBulkActionSelectedProducts(product.productId)
      if (!hasWholesaleChannel) {
        this.bulkOpProductsCountWithoutWholesaleChannel--
      }
      if (isProductFromClosedBS) {
        this.bulkOpProductsCountFromClosedBS--
      }
      if (!hasRetailChannel) {
        this.bulkOpProductsCountWithoutRetailChannel--
      }
      if (product.isCore) {
        this.bulkOpCoreProductsCount--
      }
    }
  }

  @action setBulkOpSelectedTab = tab => Object.assign(this, { bulkOpSelectedTab: tab })

  @action handleBulkOpTabChange = newTabValue => {
    this.setBulkOpSelectedTab(newTabValue.id)
    this.setIsWindowSelectionGoingOn(false)
    this.setSelectedChipsAsPerSide(true, [], null, null)
    this.setSelectedChipsAsPerSide(false, [], null, null)
  }

  @computed get isAnyEntityDraggedForBulkOp(): boolean {
    return Object.keys(this.bulkOpSelectedEntities).some(
      key => !!this.bulkOpSelectedEntities[key].length
    )
  }

  @action mouseDownEventHandlerForCollection = refNode => event => {
    if (
      !event.shiftKey &&
      event.button !== 2 &&
      this.productSelectionStore.countOfBulkActionSelectedProducts &&
      refNode?.current?.contains(event.target as Node) &&
      !this.productSelectionStore.isEnhancedProductSelectionActive
    ) {
      this.resetBulkOpSelectedProducts(event)
    }
  }

  @action
  refetchModifiedProducts = async (data, selectedProducts) => {
    const fetchPolicy: FetchPolicy = 'network-only'
    const refetchQuery = {
      query: WS_BUYING_SESSION_PRODUCTS,
      fetchPolicy,
      variables: {
        where: {
          OR: selectedProducts.map(Id => ({
            Id: {
              operation: CriteriaOperationType.EQ,
              value: Id
            }
          }))
        }
      }
    }
    if (data?.status === strings.mutationResultSuccess) {
      await apolloClient.query(refetchQuery)
    }
    this.resetBulkOpSelectedProducts()
  }

  @action
  triggerBulkOpMutation = async ({
    bsgId,
    retries = 3
  }: {
    bsgId: string
    retries?: number
  }) => {
    // May need to tweak this based on real-world perf. We think backend can handle 500
    // but smaller chunks are safer, lighter, and help show the user save progress.
    const selectedProducts = this.productSelectionStore.bulkActionSelectedProductsList
    if (!selectedProducts.length) {
      return
    }
    const {
      productConfiguration: { bulkProductTagBatchSize },
      axios: { setLoadState }
    } = stores

    if (this.isBulkOpSaveActive) {
      this.abortAndResetBulkOp()
    }

    const allClusters = concat(
      this.bulkOpSelectedEntities[strings.tagTypes.retailCluster] || [],
      this.bulkOpSelectedEntities[strings.tagTypes.wholesaleCluster] || []
    )
    const allFreeTags = concat(
      this.bulkOpSelectedEntities[strings.tagTypes.retailFreeTags] || [],
      this.bulkOpSelectedEntities[strings.tagTypes.wholesaleFreeTags] || []
    )
    const allExclusions = concat(
      this.bulkOpSelectedEntities[strings.tagTypes.clientExclusions] || [],
      this.bulkOpSelectedEntities[strings.tagTypes.zoneExclusions] || []
    )
    const allExcludedClusterIds = concat(
      this.bulkOpSelectedEntities[strings.tagTypes.wholesaleClusterExclusions] || [],
      this.bulkOpSelectedEntities[strings.tagTypes.retailClusterExclusions] || []
    )
    const salesPeriod = (
      this.bulkOpSelectedEntities[strings.tagTypes.salesPeriod] || []
    ).map(({ Id }) => Id)
    const bodyBase = {
      buyingSessionProductIds: [],
      clusterIds: (allClusters || []).map(({ Id }) => Id),
      clusterStatuses: (allClusters || []).map(
        cluster => cluster?.clusterStatusId || 'centric:'
      ),
      channelIds: (this.bulkOpSelectedEntities[strings.tagTypes.channel] || []).map(
        ({ Value }) => Value
      ),
      dropIds: (this.bulkOpSelectedEntities[strings.tagTypes.drop] || []).map(
        ({ Id }) => Id
      ),
      freeTagIds: (allFreeTags || []).map(({ Id }) => Id),
      retailSalesPeriod: salesPeriod?.length ? salesPeriod[0] : '',
      clientExclusions: (allExclusions || []).map(({ Id }) => Id),
      excludedClusterIds: (allExcludedClusterIds || []).map(({ Id }) => Id)
    }

    try {
      this.isBulkOpSaveActive = true
      this.bulkOpSaveProgress = 0
      this.bulkOpSaveError = null
      this._abortController = new AbortController()
      this._bulkOpQueue = new PQueue({ concurrency: 1 })

      const client = axios.create()
      axiosRetry(client, {
        retries,
        retryCondition: error => {
          return axios.isCancel(error) || this._abortController.signal.aborted
            ? false
            : axiosRetry.isNetworkOrIdempotentRequestError(error)
        }
      })

      const chunks = chunk(selectedProducts, bulkProductTagBatchSize)
      let completedChunks = 0
      setLoadState(true)
      await this._bulkOpQueue.addAll(
        chunks.map(chunk => async () => {
          if (this._abortController.signal.aborted) {
            return
          }

          await client.post(
            `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${bsgId}/product/bulkUpdate`,
            {
              ...bodyBase,
              buyingSessionProductIds: chunk
            },
            {
              headers: {
                Authorization: `Bearer ${storage.getItem('access_token')}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              signal: this._abortController.signal
            }
          )

          completedChunks++
          this.bulkOpSaveProgress = (completedChunks / chunks.length) * 100
        })
      )

      await this.refreshProductsAfterBulkOp(selectedProducts)
      this.hideBulkOpPopupAndResetSelections()
      this.resetBulkOpSelectedProducts() // only auto-clear selection if successful
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error('Bulk operation failed:', error)
        this.hideBulkOpPopupAndResetSelections()
        this.bulkOpSaveError = error as AxiosError<any> | Error
      }
    } finally {
      this.abortAndResetBulkOp()
      setLoadState(false)
    }
  }

  resetBulkOpError = () => {
    this.bulkOpSaveError = null
  }

  @action
  handleCancelBulkOp = async selectedProducts => {
    this.abortAndResetBulkOp()
    this.hideBulkOpPopupAndResetSelections()
    await this.refreshProductsAfterBulkOp(selectedProducts) // done after so dismiss is immediate
    // Don't clear selection.
  }

  private abortAndResetBulkOp = () => {
    if (this._abortController) {
      if (this._bulkOpQueue?.size > 0) {
        this._abortController.abort()
      }
      this._abortController = undefined
    }

    if (this._bulkOpQueue) {
      this._bulkOpQueue.clear()
      this._bulkOpQueue = undefined
    }

    this.isBulkOpSaveActive = false
    this.bulkOpSaveProgress = 0
  }

  private refreshProductsAfterBulkOp = async selectedProducts => {
    const fetchPolicy: FetchPolicy = 'network-only'
    const refetchQuery = {
      query: WS_BUYING_SESSION_PRODUCTS,
      fetchPolicy,
      variables: {
        where: {
          OR: selectedProducts.map(Id => ({
            Id: {
              operation: CriteriaOperationType.EQ,
              value: Id
            }
          }))
        }
      }
    }
    try {
      await apolloClient.query(refetchQuery)
    } catch (error) {
      console.error('Error refreshing products after bulk operation:', error)
    }
  }

  getBulkOperationWarnings = (tab, t: WithTranslationProps['i18n']['t']) => {
    let warnings: string[] = []
    const wholesaleChannelValue =
      config.appConfig?.enumerations?.channel?.VALUES?.WHOLESALE
    const isWholesaleChannelSelected = this.bulkOpSelectedEntities[
      strings.tagTypes.channel
    ]?.find(({ Value }) => Value === wholesaleChannelValue)
    const retailChannelValue = VIPChannel.Retail
    const isRetailChannelSelected = this.bulkOpSelectedEntities[
      strings.tagTypes.channel
    ]?.find(({ Value }) => Value === retailChannelValue)
    if (this.bulkOpProductsCountFromClosedBS) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountFromClosedBS
        } ${t(
          'bulkPopUp.warning.bulkOpProductsCountFromClosedBS',
          'products whose buying session is CLOSED. Clusters/Drops/Channels/Free Tags will not be applied to those.'
        )}`
      )
    }

    if (
      tab === strings.tagTypes.wholesaleCluster &&
      this.bulkOpProductsCountWithoutWholesaleChannel &&
      !isWholesaleChannelSelected
    ) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountWithoutWholesaleChannel
        } ${t(
          'bulkPopUp.warning.wholesaleCluster',
          'products which are not present in Wholesale channel. Wholesale clusters will not be applied to those.'
        )}`
      )
    }
    if (
      tab === strings.tagTypes.retailCluster &&
      this.bulkOpProductsCountWithoutRetailChannel &&
      !isRetailChannelSelected
    ) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountWithoutRetailChannel
        } ${t(
          'bulkPopUp.warning.retailCluster',
          'products which are not present in Retail channel. Retail clusters will not be applied to those.'
        )}`
      )
    }
    if (
      tab === strings.tagTypes.salesPeriod &&
      this.bulkOpProductsCountWithoutRetailChannel &&
      !isRetailChannelSelected
    ) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountWithoutRetailChannel
        } ${t(
          'bulkPopUp.warning.salesPeriod',
          'products which are not present in Retail channel. Retail sales period will not be applied to those.'
        )}`
      )
    }
    if (
      tab === strings.tagTypes.wholesaleClusterExclusions &&
      this.bulkOpProductsCountWithoutWholesaleChannel &&
      !isWholesaleChannelSelected
    ) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountWithoutWholesaleChannel
        } ${t(
          'bulkPopUp.warning.wholesaleClusterExclusions',
          'products which are not present in Wholesale channel. Wholesale cluster exclusions will not be applied to those.'
        )}`
      )
    }
    if (
      tab === strings.tagTypes.retailClusterExclusions &&
      this.bulkOpProductsCountWithoutRetailChannel &&
      !isRetailChannelSelected
    ) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpProductsCountWithoutRetailChannel
        } ${t(
          'bulkPopUp.warning.retailClusterExclusions',
          'products which are not present in Retail channel. Retail cluster exclusions will not be applied to those.'
        )}`
      )
    }
    if (tab === strings.tagTypes.zoneExclusions && this.bulkOpCoreProductsCount) {
      warnings.push(
        `${t('common.label.bulkPopUpSelected', 'You have selected')} ${
          this.bulkOpCoreProductsCount
        } ${t(
          'bulkPopUp.warning.zoneExclusions',
          'core products. Zone exclusion will not be applied to those.'
        )}`
      )
    }
    return warnings
  }

  @action removeBulkOpEntity = (entityType, entityId) => {
    const bulkOpEntity = this.bulkOpSelectedEntities[entityType].find(
      ({ Id, Value }) => (Value && Value === entityId) || (Id && Id === entityId)
    )
    if (this.bulkOpSelectedEntities[entityType] && bulkOpEntity) {
      bulkOpEntity.clusterStatus = ''
      bulkOpEntity.clusterStatusId = ''
      this.bulkOpSelectedEntities[entityType] = this.bulkOpSelectedEntities[
        entityType
      ].filter(
        ({ Id, Value }) => !((Value && Value === entityId) || (Id && Id === entityId))
      )
    }
    this.rightSideSelectedChipsForDrag = this.rightSideSelectedChipsForDrag.filter(
      ele => ele?.Id !== entityId
    )
  }

  @action addBulkOpSelectedEntity = (entityType, entity) => {
    if (!this.bulkOpSelectedEntities[entityType]) {
      this.bulkOpSelectedEntities[entityType] = []
    }
    if (
      entityType === strings.tagTypes.drop ||
      entityType === strings.tagTypes.salesPeriod
    ) {
      this.bulkOpSelectedEntities[entityType] = [
        ...this.bulkOpSelectedEntities[entityType],
        ...entity
      ]
    } else if (
      !this.bulkOpSelectedEntities[entityType].find(
        ({ Id, Value }) => (Value && Value === entity.Value) || (Id && Id === entity.Id)
      )
    ) {
      this.bulkOpSelectedEntities[entityType] = [
        ...this.bulkOpSelectedEntities[entityType],
        ...entity
      ]
    }
    this.setSelectedChipsAsPerSide(false, [], null, null)
    this.setIsWindowSelectionGoingOn(false)
  }

  @action removeBulkOpSelectedEntity = (entityType, entities, bulkOpSelectedTab) => {
    if (entities.length === 1) {
      this.removeBulkOpEntity(entityType, entities[0]?.Id)
    } else {
      if (bulkOpSelectedTab === strings.tagTypes.retailCluster) {
        this.bulkOpSelectedEntities[entityType].forEach(ele => {
          ele.clusterStatus = ''
          ele.clusterStatusId = ''
        })
      }
      const bulkOpEntities = this.bulkOpSelectedEntities[entityType].filter(
        ele => !entities.some(selected => selected?.Id === ele?.Id)
      )
      this.bulkOpSelectedEntities[entityType] = bulkOpEntities
      this.setSelectedChipsAsPerSide(true, [], null, null)
    }
    this.setSelectedChipsAsPerSide(true, [], null, null)
  }

  @computed get whereInputForClientOrderProducts() {
    const {
      queryParams: { buyingSessionGroupId, client }
    } = nav
    return {
      c8__Parent__: {
        VIPClientOrder: {
          GIV_VIPClientOrder_OrderNumber_string: {
            operation: CriteriaOperationType.NE,
            value: ''
          },
          BuyingSessionGroup: {
            Id: { operation: CriteriaOperationType.EQ, value: buyingSessionGroupId }
          },
          ...(client && {
            Client: {
              Id: { operation: CriteriaOperationType.EQ, value: client }
            }
          })
        }
      },
      OR: this.getORConditionForOrderProducts()
    }
  }

  @computed get whereInputForDoorOrderProducts() {
    const {
      queryParams: { buyingSessionGroupId, client }
    } = nav
    return {
      c8__Parent__: {
        VIPDoorOrder: {
          GIV_VIPDoorOrder_OrderNumber_string: {
            operation: CriteriaOperationType.NE,
            value: ''
          },
          BuyingSessionGroup: {
            Id: { operation: CriteriaOperationType.EQ, value: buyingSessionGroupId }
          },
          ...(client && {
            Door: {
              c8__Parent__: {
                Id: {
                  operation: CriteriaOperationType.EQ,
                  value: client
                }
              }
            }
          })
        }
      },
      OR: this.getORConditionForOrderProducts()
    }
  }

  getBuyingSessionCollection = collectionId => {
    let collection = {
      Id: { operation: CriteriaOperationType.EQ, value: collectionId }
    }
    return collection
  }

  getORConditionForOrderProducts = () => {
    return [
      {
        GIV_VIPOrderProduct_TotalQty_int: {
          operation: CriteriaOperationType.GT,
          value: 0
        }
      },
      {
        GIV_VIPOrderProduct_TotalSizedQty_int: {
          operation: CriteriaOperationType.GT,
          value: 0
        }
      }
    ]
  }

  /**
   * addSalesPeriodToBSP
   * @param buyingSessionProductId - Product id
   * @param salesPeriod - Sales period id
   */
  @action addSalesPeriodToBSP = async (buyingSessionProduct, salesPeriod) => {
    const refetchQuery = {
      query: GET_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProductID: buyingSessionProduct
      }
    }

    await apolloClient.mutate({
      mutation: ADD_SALES_PERIOD_TO_BUYING_SESSION_PRODUCT,
      variables: {
        buyingSessionProduct,
        salesPeriod
      },
      awaitRefetchQueries: true,
      refetchQueries: [refetchQuery]
    })
  }

  @action getAssortmentProductsByType = async (
    buyingSessionGroupId: string,
    clientId: string,
    type: BuyingSessionAssortmentType.door | BuyingSessionAssortmentType.client,
    doorId?: string,
    refetch?: true
  ) => {
    try {
      this.assortmentProduct = {
        ...this.assortmentProduct,
        loading: !refetch,
        items: refetch ? this.assortmentProduct.items : []
      }
      const response =
        type === BuyingSessionAssortmentType.client
          ? await this.commonService.getClientAssormentProducts(
              buyingSessionGroupId,
              clientId
            )
          : type === BuyingSessionAssortmentType.door
          ? await this.commonService.getDoorAssormentProducts(
              buyingSessionGroupId,
              clientId,
              doorId
            )
          : null

      this.assortmentProduct = {
        loading: false,
        error: '',
        items: response.length ? response : []
      }
    } catch (e) {
      console.log(e)
      this.assortmentProduct = {
        ...this.assortmentProduct,
        loading: false,
        error: e as string
      }
    }
  }

  resetBulkOpData = () => {
    this.productSelectionStore.resetAllSelectionData()
    this.isBulkOpSaveActive = false
    this.bulkOpSaveProgress = 0
    this.resetBulkOpError()
    this._abortController = new AbortController()
  }
}
